import { useEffect } from "react";
import { toast } from "react-toastify";
import { NEW_BOOKING_CREATED_EVENT } from "../types/parcelBookingSignalR.types";
import { dispatchNotificationsRefresh } from "../types/notification.types";
import getSignalRService from "../services/signalRService";
import { useNotifications } from "../context/NotificationContext";
import {
  dispatchParcelBookingRefresh,
  formatParcelBookingToastMessage,
  shouldSuppressParcelBookingNotification,
} from "../utils/parcelBookingNotifications";

/**
 * Subscribes to NewBookingCreated — refreshes notifications from API + toast.
 */
export function useParcelBookingNotifications(enabled = true) {
  const { refreshNotifications } = useNotifications();

  useEffect(() => {
    if (!enabled) return undefined;

    const service = getSignalRService();
    service.ensureBookingListenerRegistered();

    const handleParcelBookingCreated = (payload) => {
      if (process.env.NODE_ENV === "development") {
        console.info("[SignalR] NewBookingCreated handler", payload);
      }

      const isSelf = shouldSuppressParcelBookingNotification(payload);

      refreshNotifications();
      dispatchNotificationsRefresh();
      dispatchParcelBookingRefresh(payload);

      if (!isSelf) {
        toast.info(formatParcelBookingToastMessage(payload), {
          position: "top-right",
          autoClose: 8000,
        });
      }
    };

    service.on(NEW_BOOKING_CREATED_EVENT, handleParcelBookingCreated);

    return () => {
      service.off(NEW_BOOKING_CREATED_EVENT, handleParcelBookingCreated);
    };
  }, [refreshNotifications, enabled]);
}

export default useParcelBookingNotifications;
